import { Button, CopyButton, Group, Paper, Text } from '@mantine/core';
import { IconArrowLeft, IconCheck, IconLink, IconPrinter } from '@tabler/icons-react';
import { Link, useParams } from 'react-router';
import { ZaslonSeznama } from '../seznam/Seznam';
import { clanek } from './clanki';
import { ClanekVsebina } from './ClanekVsebina';

/**
 * Članek pomoči v aplikaciji ({@code /pomoc/:clanek}); »Kopiraj povezavo« da javno povezavo ({@code /navodila/…}),
 * ki jo lahko pošljemo stranki v mailu ali novici – deluje tudi brez prijave.
 */
export function ClanekPomoci() {
  const { clanek: id } = useParams();
  const c = clanek(id);
  return (
    <ZaslonSeznama>
      <Group justify="space-between" mb="xs" gap="xs">
        <Button component={Link} to="/pomoc" variant="subtle" leftSection={<IconArrowLeft size={16} />} px={0}>
          Pomoč
        </Button>
        {c && (
          <Group gap="xs">
            <CopyButton value={`${window.location.origin}/navodila/${c.id}`}>
              {({ copied, copy }) => (
                <Button
                  size="xs"
                  variant="light"
                  onClick={copy}
                  leftSection={copied ? <IconCheck size={14} /> : <IconLink size={14} />}
                >
                  {copied ? 'Kopirano' : 'Kopiraj povezavo'}
                </Button>
              )}
            </CopyButton>
            <Button
              size="xs"
              variant="subtle"
              leftSection={<IconPrinter size={14} />}
              onClick={() => window.print()}
              visibleFrom="sm"
            >
              Natisni
            </Button>
          </Group>
        )}
      </Group>
      <Paper radius="lg" p={{ base: 'md', sm: 'xl' }} shadow="xs" maw={900}>
        {c ? (
          <ClanekVsebina clanek={c} osnova="/pomoc" />
        ) : (
          <Text>Navodila ne obstajajo (več). Poiščite jih na strani Pomoč.</Text>
        )}
      </Paper>
    </ZaslonSeznama>
  );
}
